const vendorConsentByOsTransformer = (data, defaultData) => {
  return data.reduce((acc, current) => {
    if (current.os == "ios" && current.spt_consent) {
      acc.series[0].data[0] += current.active_devices
    } else if (current.os == "ios" && !current.spt_consent) {
      acc.series[1].data[0] += current.active_devices
    } else if (current.os == "android" && current.spt_consent) {
      acc.series[0].data[1] += current.active_devices
    } else if (current.os == "android" && !current.spt_consent) {
      acc.series[1].data[1] += current.active_devices
    }
    return acc
  }, {...defaultData} )
}

export default vendorConsentByOsTransformer